import { render, staticRenderFns } from "./MainItineraryActions.vue?vue&type=template&id=54f54b86&scoped=true&"
import script from "./MainItineraryActions.vue?vue&type=script&lang=js&"
export * from "./MainItineraryActions.vue?vue&type=script&lang=js&"
import style0 from "./MainItineraryActions.vue?vue&type=style&index=0&id=54f54b86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f54b86",
  null
  
)

export default component.exports